export enum EmailSubscriptionType {
  StudioNotificationSubscribed = 'studio_notification_subscribed',
  ReviewNotificationSubscribed = 'review_notification_subscribed',
  BlogNotificationSubscribed = 'blog_notification_subscribed',
  RequestNotificationSubscribed = 'request_notification_subscribed',
  ShowcaseReviewNotificationSubscribed = 'showcase_review_notification_subscribed',
}
